import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { localForage } from '@/utils/services'

@Module({ namespaced: true, name: 'files' })
export default class ModuleFiles extends VuexModule {

    data: any = {}

    @Mutation
    store(payload: any) {
        this.data[payload.uniqueId] = []
        this.data[payload.uniqueId] = payload.files
    }

    @Action
    process(uniqueId: string) {

        if (this.data[uniqueId].length) {
            localForage.files.setItem(uniqueId, this.data[uniqueId])
        }
    }
}